import { Longform } from "@anthra/ui/typography"
import { createFileRoute } from "@tanstack/react-router"

import { Points, ProsePage, Section } from "@/components/prose-page"

/**
 * Privacy notice.
 *
 * Describes the data this codebase actually handles: a mobile number, a name,
 * an optional email, a user type, uploaded documents, and the thread. Nothing
 * here claims a practice the product does not have.
 *
 * LIKE THE TERMS, THIS HAS NOT BEEN REVIEWED BY A LAWYER. India's DPDP Act
 * obligations — notice content, consent, grievance officer, retention periods —
 * are the parts most likely to need adjusting, and the retention period below
 * is deliberately left to be filled in rather than invented.
 */
export const Route = createFileRoute("/privacy")({ component: Privacy })

function Privacy() {
	return (
		<ProsePage
			title="Privacy notice"
			updated="2026-08-25"
			intro="What we collect, why we hold it, and what you can ask us to do with it."
		>
			<Section title="What we collect">
				<Points
					items={[
						"Your WhatsApp number, which is how you sign in.",
						"Your name, and your email address if you give one.",
						"The documents you upload and the questions you write.",
						"Basic technical records of requests to the service, kept to keep it running and secure.",
					]}
				/>
			</Section>

			<Section title="Why we hold it">
				<Points
					items={[
						"To sign you in and keep your session open.",
						"To let an expert read your Queries/Drafts/Documents and answer it.",
						"To send you OTPs and notifications on WhatsApp.",
						"To keep your questions and documents together so you can find them later.",
					]}
				/>
				<Longform>
					We do not sell your information, and we do not use your documents to advertise
					to you.
				</Longform>
			</Section>

			<Section title="Who can see it">
				<Points
					items={[
						"You Can.",
						"The experts on our panel who work on your question/vetting request.",
						"WhatsApp, which carries the OTPs and notifications we send to your number.",
						"Service providers who host the system, under contract and only to run it.",
					]}
				/>
			</Section>

			<Section title="Your documents">
				<Longform>
					Links to a document are short-lived and generated fresh each time it is opened,
					so a link that is copied or forwarded stops working.
				</Longform>
			</Section>

			<Section title="How long we keep it">
				<Longform>
					We keep your account and your threads while your account is open, and for a
					period afterwards where we are required to. That period is being confirmed and
					will be stated here.
				</Longform>
			</Section>

			<Section title="What you can ask for">
				<Points
					items={[
						"Deletion of your account and its contents, where we are not required to keep it.",
					]}
				/>
				<Longform>Write to help@swamithra.com and we will handle it.</Longform>
			</Section>

			<Section title="Contact">
				<Longform>
					Swamithra Tax KPO Private Limited, Hyderabad. Privacy questions and complaints
					go to help@swamithra.com.
				</Longform>
			</Section>
		</ProsePage>
	)
}
